import React from "react";
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import "bootstrap/dist/css/bootstrap.min.css";
import CustomNavbar from "./component/Navbar";
import HeroSection from "./component/HeroSection";
import Services from "./component/Services"; 
import Home from "./component/Home";
import QuoteSection from "./component/QuoteSection";
import Footer from "./component/Footer";
import TwoDModeling from "./component/2DModeling";
import ThreeDModeling from "./component/3DModeling";
import DesignServices from "./component/DesignServices";
//import QuantitativeSurvey from "./component/QuantitativeSurvey";
//import ManpowerOutsourcing from "./component/ManpowerOutsourcing";
import Gallery from "./component/Gallery";
import ContactUs from "./component/ContactUs";
import TrainingAndDevelopment from './component/TrainingAndDevelopment';
import JPEPage from './component/JPEPage';
import CourseDetail from './component/CourseDetail';
import TrainingProgramDetail from './component/TrainingProgramDetail';
// import BlogList from "./component/BlogList";
// import BlogPost from "./component/BlogPost";
// import BlogUpload from "./component/BlogUpload";

import { FaDownload } from "react-icons/fa";
import "./App.css";

function App() {
  const handleDownload = () => {
    window.open("/templates/work-template.pdf", "_blank"); // Replace with actual PDF path
  };

  return (
    <HelmetProvider>
      <Router>
        <div className="app">
          <CustomNavbar />
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={
              <>
                <HeroSection />
                <hr className="section-separator" />
                <Services />
                <div className="text-center my-4">
                  <button
                    onClick={handleDownload}
                    className="brochure-thumbnail"
                    title="View Brochure"
                  >
                    <img src="/NAEW1.png" alt="View Brochure" style={{ height: '40px', marginRight: '8px' }} />
                    View Brochure
                  </button>
                </div>
                <Home />
                <QuoteSection />
                <Footer />
              </>
            } />
            {/* Blog Routes */}
            {/* <Route path="/blog" element={<BlogList />} />
            <Route path="/blog/upload" element={<BlogUpload />} />
            <Route path="/blog/:slug" element={<BlogPost />} /> */}
            {/* <Route path="/about" element={<AboutUs />} /> */}
            <Route path="/2d-modeling" element={<TwoDModeling />} />
            {/* <Route path="/manpower-outsourcing" element={<ManpowerOutsourcing />} /> */}
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/contact-us" element={<ContactUs />} />
            <Route path="/training-and-development" element={<TrainingAndDevelopment />} />
            <Route path="/tandd" element={<Navigate to="/training-and-development" replace />} />
            <Route path="/tandd/:programName" element={<TrainingProgramDetail />} />
            <Route path="/jpe" element={<JPEPage />} />
            <Route path="/course/:id" element={<CourseDetail />} />
            <Route path="/3d-modeling" element={<ThreeDModeling />} />
            <Route path="/design-services" element={<DesignServices />} />
            {/* <Route path="/quantitative-survey" element={<QuantitativeSurvey />} /> */}
            
            {/* Redirects */}
            <Route path="/home" element={<Navigate to="/" replace />} />
            <Route path="/services" element={<Navigate to="/" replace />} />
            <Route path="/gallery" element={<Navigate to="/" replace />} />
            <Route path="/about-us" element={<Navigate to="/about" replace />} />

          
            <Route path="/contact" element={<ContactUs />} />

           
          </Routes>

          {/* Floating WhatsApp Button */}
          <a
            href="https://wa.me/+917044478562"
            className="whatsapp-button"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src="/1whatsapp-icon.png" alt="WhatsApp" />
          </a>
        </div>
      </Router>
    </HelmetProvider>
  );
}

export default App;
